import { createI18n } from 'vue-i18n';
import { createStore } from '@workflow-solutions/siteflow-section-layout';

import { sectionName } from '../lib/config';

const store = createStore({
	persistedStatePaths: {
		// do not remove all the paths in this object
		// otherwise it will save all the store in local storage
		doNotRemove: {}
	},
	sectionName
});

const i18n = createI18n({
	silentFallbackWarn: true,
	silentTranslationWarn: true
});
export const $t = str => i18n.global.t(str);

export { store, i18n };
